import React from 'react'
import PropTypes from 'prop-types'
import { ImprintTemplate } from '../../templates/imprint-template.js'

const ImprintPagePreview = ({ entry }) => {
  const data = entry.getIn(['data']).toJS()
  console.log(data)

  if (data) {
    return (
      <ImprintTemplate
        imprint = {data}
      />
    )
  } else {
    return <div>Loading...</div>
  }
}

ImprintPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
}

export default ImprintPagePreview